import React from 'react';

function Team({ member }) {
    //Variables
    const { name, avatar } = member || {};

    //JSX
    return (
        <div className="checkbox-container">
            <img src={avatar} className="team-avater" alt="team-pic" />
            <p className="label">{name}</p>
        </div>
    )
}

export default Team